import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import RolesTable from './RolesTable';
import AddRoles from './AddRoles';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import RolesColumnFilterModal from './RolesColumnFilterModal';
import RolesValueFilterModal from './RolesValueFilterModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadRolesDropdownData, loadSettingsRolesData, loadSingleSettingsRolesData, postRolesDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import * as XLSX from 'xlsx';  // For Excel file creation
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import RolesBulkUploadModal from './RolesBulkUploadModal';

const statusOptions = [
    { value: 24, label: "Active" },
    { value: 25, label: "Inactive" }
];

const Roles = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { getRolesData = [] } = useSelector((state) => state.data);
    const { getSingleRolesData } = useSelector((state) => state.data);
    const { rolesDropdown } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [roleId, setRoleId] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedColumns, setSelectedColumns] = useState([
        "ROLE NAME", "DESCRIPTION", "STATUS", "ACTION"
    ]);
    const [selectedRoleID, setSelectedRoleID] = useState(null);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [advancedExpression, setAdvancedExpression] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const handleRoleSelection = (selectedRole) => {
        if (selectedRole) {
            const roleID = selectedRole.value;  // Extract RoleID (assuming value represents RoleID)
            setSelectedRoleID(roleID);  // Store RoleID in state
            getRoles(roleID, selectedStatusID);  // Call API with both RoleID and current StatusID
        }
    };

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            getRoles(selectedRoleID, statusID);  // Call API with both StatusID and current RoleID
        }
    };

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSingleSettingsRolesData(userRefId, setDataLoading));
        } else {
            getRoles();
        }
    }, [userRefId]);

    const getRoles = (roleID = null, statusID = null) => {
        dispatch(loadSettingsRolesData(setLoading, roleID, statusID))
    }

    useEffect(() => {
        getRoles();
    }, []);

    useEffect(() => {
        dispatch(loadRolesDropdownData());
    }, [])

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleOpenModal = (roleID) => {
        setIsModalOpen(true);
        if (roleID) {
            dispatch(loadSingleSettingsRolesData(roleID, setDataLoading));
            setRoleId(roleID);
        } else {
            setRoleId("");
        }
    };

    const handleCloseModal = () => {
        setRoleId("");
        dispatch(loadSingleSettingsRolesData(null, setDataLoading));
        setIsModalOpen(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 24 : 25; // 24 for Active, 25 for Inactive

        console.log(customer, 'customer')
        const data = {
            RoleID: customer.RoleID,
            RoleName: customer.RoleName,
            Description: customer.Description,
            StatusID: statusID,
            RoleModulePermission: customer.RoleModulePermission,
            AddedByID: ADDED_BY_ID,
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postRolesDatas(requestOption, handleCloseModal, getRoles, customer.RoleID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedRoleID(null);
        setSelectedStatusID(null);
        getRoles();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Roles"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Roles</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                {/* <div style={{ width: "100%" }}> */}
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder=" Select Role"
                                        options={rolesDropdown}
                                        style={{ width: "100%" }}
                                        value={selectedRoleID ? rolesDropdown.find(role => role.value === selectedRoleID) : null}
                                        onChange={(selectedOption) => handleRoleSelection(selectedOption)}
                                    />
                                </Col>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                {/* </div> */}
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />} */}
                                {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <RolesTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                getRolesData={getRolesData}
                                loading={loading}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                signInDetails={signInDetails}
                                PreviousCompanyID={PreviousCompanyID}
                                userRefId={userRefId}
                                getSingleRolesData={getSingleRolesData}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddRoles
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getRoles={getRoles}
                    roleId={roleId}
                    getSingleRolesData={getSingleRolesData}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <RolesBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    getRoles={getRoles}
                />
            }
            {showColumnFilterModal && (
                <RolesColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <RolesValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                    advancedExpression={advancedExpression}
                    setAdvancedExpression={setAdvancedExpression}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default Roles;